<ng-container *ngIf="invitations$ | async as state">
  <app-feature-list-container
    [title]="
      customerNumber
        ? ('GATEWAY.USER_INVITATION_LIST.TITLE' | translate)
        : ('GATEWAY.INVITATION_LIST.TITLE' | translate)
    "
  >
    <vi-loader *ngIf="!state.isData && state.loading" data-at-loader [isLoading]="true">
    </vi-loader>

    <ng-container *ngIf="state.loaded">
      <div class="header-row" [class.with-scrollbar]="isScrollbarVisible()">
        <div
          class="header-row-inner flex flex-row xs:flex-col justify-start items-center xs:items-start"
        >
          <vi-dropdown
            data-at-event-type-filter
            class="gt-xs:flex-[18%] gt-xs:max-w-[18%]"
            [options]="statusFilters"
            [option]="initialFilter"
            width="80%"
            (optionChange)="onFilterChange($event)"
          >
          </vi-dropdown>
          <div class="header-row-item gt-xs:flex-[22%] gt-xs:max-w-[22%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.LAST_STATUS_CHANGE' | translate }}
          </div>
          <div class="header-row-item gt-xs:flex-[30%] gt-xs:max-w-[30%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITER' | translate }}
          </div>
          <div class="header-row-item gt-xs:flex-[30%] gt-xs:max-w-[30%]">
            {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITEE' | translate }}
          </div>
        </div>
      </div>
      <ng-container *ngIf="state.isData; else noResult">
        <app-infinite-scroll
          [state$]="invitations$"
          [search$]="searchType$"
          [itemSize]="itemSize"
          [limit]="limit"
          [(nextBatch)]="nextBatch"
          (nextBatchChange)="onNextBatchChange($event)"
          (fetchNext)="onFetchNext($event)"
        >
          <cdk-virtual-scroll-viewport [itemSize]="itemSize" #viewport>
            <div *cdkVirtualFor="let token of state.invitationsIds" class="list-item">
              <app-invitation-list-item
                class="flex flex-row xs:flex-col invitation-list-item"
                [invitation]="state.invitations[token]"
                [inviter]="state.inviterDetails[state.invitations[token].inviterAccount]"
                [invitee]="state.inviteeDetails[state.invitations[token].inviteeAccount]"
                [inviteeCompany]="
                  state.inviteeCompanyDetails[state.invitations[token].customerNumber]
                "
                [inviterCompany]="
                  state.inviterCompanyDetails[state.invitations[token].inviterCustomerNumber]
                "
              ></app-invitation-list-item>
            </div>
            <vi-loader
              *ngIf="nextBatch"
              [isLoading]="true"
              message="{{ 'GATEWAY.INVITATION_LIST.LOADING_MORE' | translate }}"
            ></vi-loader>
          </cdk-virtual-scroll-viewport>
        </app-infinite-scroll>
      </ng-container>

      <ng-template #noResult>
        <div class="no-results">{{ 'GATEWAY.INVITATION_LIST.NO_RESULTS' | translate }}</div>
      </ng-template>
    </ng-container>
  </app-feature-list-container>
</ng-container>
